module.exports = __webpack_public_path__ + "static/media/report_soft_skill.22f9b7e0.png";